<template>
  <div style="padding: 5px;">
    <a-card>
      <div style="text-align: right;">
        <span
          class="ant-descriptions-title"
          style="float: left; margin-top: 5px;"
        >
          <a-icon type="tags" /> List Shift
        </span>
        <a-input
          placeholder="Search shift..."
          style="width: 350px; max-width: 100%; margin-right: 5px;"
          @change="onFilter"
          v-model="filter.query"
        />
        <a-button
          slot="extra"
          type="primary"
          @click="() => (visibleAdd = true)"
        >
          <a-icon type="plus" /> Add New
        </a-button>
      </div>

      <a-table
        :columns="columnsAllWorkShift"
        :data-source="workShifts"
        size="small"
        :loading="loadingList"
        rowKey="id"
        :pagination="{
          current: currentPage,
          onChange: (page) => {
            this.currentPage = page;
          },
          pageSize: limit,
        }"
        :scroll="workShifts.length > 0 ? { x: 1600 } : {}"
      >
        <div slot="footer">
          <a-button
            :loading="loadingList"
            type="link"
            @click="onPagination"
            :disabled="!isPagination"
          >
            <a-icon type="reload" /> Load more
          </a-button>
        </div>
        <div slot="stt" slot-scope="text, record, index">
          {{ index + 1 }}
        </div>

        <span slot="isOvertime" slot-scope="text">
          <p v-if="text">
            <a-icon type="check" style="margin-left: 5px; color: #52c419;" />
          </p>
        </span>
        <span slot="startTime" slot-scope="text">
          {{ text | formatTime }}
        </span>
        <span slot="endTime" slot-scope="text">
          {{ text | formatTime }}
        </span>
        <span slot="createdAt" slot-scope="text">
          {{ text | formatDateHour }}
        </span>
        <span slot="updatedAt" slot-scope="text">
          {{ text | formatDateHour }}
        </span>
        <span slot="action" style="float: right;" slot-scope="text, record">
          <a-button @click="collapseVisibleEdit(record.id)">
            <a-icon title="Chỉnh sửa" type="edit" /> Edit
          </a-button>
        </span>
      </a-table>

      <a-drawer
        v-if="visibleEdit"
        title="Edit"
        placement="right"
        :visible="visibleEdit"
        @close="() => (visibleEdit = false)"
        :width="450"
        :bodyStyle="{ height: 'calc(100% - 100px)', overflowY: 'auto' }"
      >
        <EditWorkShift
          :idWorkShift="idWorkShift"
          :close="() => (visibleEdit = false)"
          :refreshAfterUpdated="refreshAfterUpdated"
          :refreshAfterDeleted="refreshAfterDeleted"
        />
      </a-drawer>

      <a-drawer
        v-if="visibleAdd"
        title="Add New"
        placement="right"
        :visible="visibleAdd"
        @close="() => (visibleAdd = false)"
        :width="450"
        :bodyStyle="{ height: 'calc(100% - 100px)', overflowY: 'auto' }"
      >
        <AddWorkShift
          :close="() => (visibleAdd = false)"
          :refreshAfterCreated="refreshAfterCreated"
        />
      </a-drawer>
    </a-card>
  </div>
</template>
<script>
import { columnsAllWorkShift } from "./constant/column";
import AddWorkShift from "./components/addWorkShift";
import EditWorkShift from "./components/editWorkShift";
import query from "./constant/query";
import {
  updateForCreated,
  updateForUpdated,
  updateForDeleted,
} from "@/services/updateOnViewConfig";
import debounce from "lodash/debounce";
const limit = 10;
const startPage = 1;
const defaultFilter = { query: "", status: "ACTIVE" };
export default {
  components: {
    AddWorkShift,
    EditWorkShift,
  },
  data() {
    this.onFilter = debounce(this.onFilter, 500);
    return {
      limit,
      visibleEdit: false,
      visibleDetail: false,
      visibleAdd: false,
      columnsAllWorkShift,
      loadingList: true,
      workShifts: [],
      idWorkShift: "",
      filter: defaultFilter,
      currentPage: startPage,
      totalPage: startPage,
      isPagination: true,
    };
  },
  methods: {
    onGetAllWorkShift(flag) {
      this.loadingList = true;
      this.$apollo
        .query({
          query: query.getAllWorkShift,
          fetchPolicy: "no-cache",
          variables: {
            limit,
            query: this.filter.query,
            page: this.totalPage,
          },
        })
        .then(({ data }) => {
          this.loadingList = false;
          if (data?.getAllWorkShift?.length >= 0) {
            if (flag === "FILTER") {
              this.workShifts = [...data.getAllWorkShift];
            } else if (flag === "PAGINATION") {
              this.workShifts = this.workShifts.concat([
                ...data.getAllWorkShift,
              ]);
            } else {
              this.workShifts = [...data.getAllWorkShift];
            }
            // check is pagniation
            if (data.getAllWorkShift.length < limit) {
              this.isPagination = false;
            } else {
              this.isPagination = true;
            }
          }
        })
        .catch((err) => {
          console.error(
            "Lấy danh sách địa điểm làm việc không thành công",
            err
          );
        });
    },
    collapseVisibleDetail(id) {
      if (id) {
        this.idWorkShift = id;
        this.visibleDetail = true;
      } else {
        this.idWorkShift = "";
        this.visibleDetail = false;
      }
    },
    collapseVisibleEdit(id) {
      if (id) {
        this.idWorkShift = id;
        this.visibleEdit = true;
      } else {
        this.idWorkShift = "";
        this.visibleEdit = false;
      }
    },
    onFilter() {
      this.currentPage = startPage;
      this.totalPage = startPage;
      this.onGetAllWorkShift("FILTER");
    },
    refreshAfterUpdated(item) {
      this.workShifts = updateForUpdated(this.workShifts, item);
    },
    refreshAfterDeleted(item) {
      this.workShifts = updateForDeleted(this.workShifts, item);
    },
    refreshAfterCreated(item) {
      this.workShifts = updateForCreated({
        list: this.workShifts,
        item,
        limit,
        currentPage: this.currentPage,
      });
    },
    onPagination() {
      if (this.isPagination) {
        this.totalPage += 1;
        this.currentPage = this.totalPage;
        this.onGetAllWorkShift("PAGINATION");
      }
    },
    onChangeStatusFilter(status) {
      this.$set(this.filter, "status", status || undefined);
      this.onFilter();
    },
  },
  created() {
    this.onGetAllWorkShift();
  },
};
</script>
<style lang="css" scoped></style>
